import { configureStore } from "@reduxjs/toolkit";
import Blog_Reducer from "../Blog-Reducer/Reducer";
import AuthSlicer from "../Components/Authentication/AuthSlice";

const Store = configureStore({
  reducer: { Auth: AuthSlicer.reducer, Blog: Blog_Reducer.reducer },
});

export default Store;
